import { Req, formatNum, getUrlParams } from './../util/util';
let orderNum = getUrlParams('orderNum');
if(!orderNum) alert("Test Nomor perintah hilang");

$(()=>{
    const methodsNames = {
        VA_BCA:'BCA',
        'BCA-BANK':'BCA',
        VA_MANDIRI:'Mandiri',
        VA_PERMATA:"Permata",
        VA_BNC:"BNC",
        VA_CIMB:"CIMB",
        VA_BNI:"BNI",
        'BNI-BANK':"BNI",
        VA_MAYBANK:"Maybank",
        VA_BRI:"BRI",
        VA_DANAMON:"Danamon",
        OVO: "OVO",
        DANA: "DANA",
        ALFAMART: "ALFAMART",
        DT: "INDOMART",
        QRIS: "EWallet Scan",
        ATMBERSAMA:'ATM Bersama',
        SASP:'Sahabat Sampoerna'
    }

    getData();
    expandMenu();

    //获取订单数据
    function getData(){
        if(!orderNum) return ;
        Req({
            url: "/gateway/getPayMethod/v2",
            type: "POST",
            data: JSON.stringify({
                orderNum
            })
        }, res=>{
            let {
                walletMethod=[], storeMethod=[],
                bankMethod=[], vaMethod=[],
                customerName, payMoney,
                name, redirectUrl, onMethod, jumpUrl,expiryTime,payStatus,validDate
            } = res.data || {};

            if(!jumpUrl){
                // console.log("11");
            }else {
                // console.log("22");
                window.location.href = jumpUrl;
                return;
            }

            if ("EXPIRED" == payStatus) {
                window.location.href = "./html/TIMEOUT.html?orderNum="+orderNum;
                return;
            }

            $(".total-number .number").html(formatNum(payMoney));
            $(".card-footer-info .no").html(orderNum);
            $(".card-footer-info .barang").html(customerName);
            $("#expiryPeriod").html(Math.ceil(expiryTime/60));
            $("#validDate").html(validDate);

            //va 列表渲染
            if(vaMethod && vaMethod.length){
                let bankListHtml = '<div class="halfpxline"></div>';
                vaMethod.forEach((item, index)=>{
                    bankListHtml += `
                    <a class="${item}" href="./html/${ item }.html?type=${item}&orderNum=${ orderNum || "" }">
                        <div class="item">
                            <div class="item-content">
                                <img src="./img/bank/${ item }.png" style="width: 80px;height: 24px;" alt="">
                                
                            </div>
                        </div>
                    </a>
                `;
                });
                bankListHtml += '<div class="halfpxline"></div>';
                $(".list-container .va .menu-items").html(bankListHtml);
                $(".list-container .va").show();
            }else{
                $(".list-container .va").hide();
            }

            //bank 列表渲染
            if(bankMethod && bankMethod.length){
                let bankListHtml = '<div class="halfpxline"></div>';
                bankMethod.forEach((item, index)=>{
                    bankListHtml += `
                    <a class="${item}" href="./html/${ item }.html?type=${item}&orderNum=${ orderNum || "" }">
                        <div class="item">
                            <div class="item-content">
                                <img src="./img/bank/${ item }.png" style="width: 80px;height: 24px;" alt="">
                            </div>
                        </div>
                    </a>
                `;
                });
                bankListHtml += '<div class="halfpxline"></div>';
                $(".list-container .bank .menu-items").html(bankListHtml);
                $(".list-container .bank").show();
            }else{
                $(".list-container .bank").hide();
            }

            //wallet 列表渲染
            if(walletMethod && walletMethod.length){
                let walletListHtml = '<div class="halfpxline"></div>';
                walletMethod.forEach((item, index)=>{
                    walletListHtml += `
                    <a href="./html/${ item }.html?type=${ item }&orderNum=${ orderNum || "" }">
                        <div class="item">
                            <div class="item-content">
                                <img src="./img/wallet/${ item }.png" style="width: 80px;height: 24px;" alt="">
                            </div>
                        </div>
                    </a>
                `;
                });
                walletListHtml += '<div class="halfpxline"></div>';
                $(".list-container .wallet .menu-items").html(walletListHtml);
                $(".list-container .wallet").show();
            }else{
                $(".list-container .wallet").hide();
            }

            //store 列表渲染
            if(storeMethod && storeMethod.length){
                let storeListHtml = '<div class="halfpxline"></div>';
                storeMethod.forEach((item, index)=>{
                    storeListHtml += `
                    <a href="./html/FT.html?type=FT&orderNum=${ orderNum || "" }">
                        <div class="item">
                            <div class="item-content">
                                <img src="./img/store/FT.png" style="width: 80px;height: 24px;" alt="">
                            </div>
                        </div>
                    </a>
                `;
                });
                storeListHtml += '<div class="halfpxline"></div>';
                $(".list-container .store .menu-items").html(storeListHtml);
                $(".list-container .store").show();
            }else{
                $(".list-container .store").hide();
            }

            $('.back-to-last').click(e => {
                location.href = redirectUrl;
                return false;
            });
        }, error=>{
            console.log(error)
        })
    }
    //绑定展开菜单的事件
    function expandMenu(){
        $('.list-container .menu').click(function(){
            // $('.list-container .menu.active').removeClass('active')
            // $(this).addClass("active");
        });
    }
});
